import { html } from "lit";
import { renderStandardPictureElement } from "../../../../utils";

type ItemType = {
    headline: string;
    description: string;
};

const exampleSlides: ItemType[] = [
    {
        headline: "Für Gerade- und Radiuskanten",
        description:
            "Schweißnahtvorbereitung an Außen- und Innenkonturen. Mit Innenausschnitten ab 130 mm Durchmesser. Auch für T- und Doppel-T-Träger.",
    },
    {
        headline: "Rohre",
        description:
            "Schweißnahtvorbereitung an Rohren ab Innendurchmesser von 30 mm.",
    },
];

const renderSlide = ({ headline, description }: ItemType) => html`
    <ux-slider-slide>
        <div class="ux-row ux-u-mx-zero ux-u-flex-jc-center">
            <div class="ux-col-12 ux-col-sm-10">
                <!-- BEGIN Slide Image -->
                ${renderStandardPictureElement({
                    width: 1600,
                    height: 900,
                })}
                <!-- END Slide Image -->

                <!-- BEGIN Slide Content -->
                <div class="ux-t-container">
                    ${headline &&
                    html`<h2 class="ux-text-title ux-text-title--light">
                        ${headline}
                    </h2>`}
                    ${description &&
                    html`<p class="ux-text-normal ux-text-normal--light-gray">
                        ${description}
                    </p>`}
                </div>
                <!-- END Slide Content -->
            </div>
        </div>
    </ux-slider-slide>
`;

export const ProductImageSliderTemplate = () => html`
    <!-- BEGIN ProductImageSlider -->
    <ux-slider loop arrows-follow-img>
        <!-- BEGIN Loop -->
        ${exampleSlides.map(renderSlide)}
        <!-- END Loop -->
        <ux-slider-pagination
            slot="pagination"
            bottom-pagination
        ></ux-slider-pagination>
    </ux-slider>
    <!-- END ProductImageSlider -->
`;

export const TabApplications = () => html`
    <div id="tabApplications">${ProductImageSliderTemplate()}</div>
`;
